import store from "@/store";

export const ENV_LABEL_DEV = ["development", "dev2", "sandbox", "rc", "qa", "stg", "latest"];
export const ENV_LABEL_PROD = "prod";

const getEnvLabel = () => {
  const [designation, currentAppMode] = store.getters["config/getAppEnvironment"]?.split("-") || [];
  return currentAppMode?.toLowerCase() || designation;
};

export const isProductionEnv = () => {
  return getEnvLabel() === ENV_LABEL_PROD;
};

export const isDevelopmentEnv = () => {
  const envLabel = getEnvLabel();
  return ENV_LABEL_DEV.some((value) => value === envLabel);
};

export const debugEnabled = () => localStorage.getItem("DEBUG_MODE") === "true" && isDevelopmentEnv();
